import { useState, } from 'react';

import PersonRequirementsData from './PersonRequirementsData';

const usePersonRequirements = () => {
  const [memberRequirementState, setMemberRequirementState] = useState(PersonRequirementsData.INITIAL_STATE);
  const [adminEnrollmentState, setAdminEnrollmentState] = useState(PersonRequirementsData.INITIAL_STATE);
  const [deleteEnrollmentState, setDeleteEnrollmentState] = useState(PersonRequirementsData.INITIAL_STATE);

  const getPersonRequirements = (personId) => {
    PersonRequirementsData.getPersonRequirements(personId, memberRequirementState, setMemberRequirementState);
  };

  
  const getPersonRequirementsAdvanced = (personId) => {
    PersonRequirementsData.getPersonRequirementsAdvanced(personId, memberRequirementState, setMemberRequirementState);
  };


  const postEnrollmentMemberRequirementAdmin = (courseId, personId, dateObj) => {
    PersonRequirementsData.postEnrollmentMemberRequirementAdmin(courseId, personId, dateObj, adminEnrollmentState, setAdminEnrollmentState);
  };


  const deletePersonRequirementEnrollment = (courseEnrollmentId) => {
    PersonRequirementsData.deletePersonRequirementEnrollment(courseEnrollmentId, deleteEnrollmentState, setDeleteEnrollmentState);
  };


  return {
    memberRequirementState,
    setMemberRequirementState,
    getPersonRequirements,
    postEnrollmentMemberRequirementAdmin,
    adminEnrollmentState,
    setAdminEnrollmentState,
    getPersonRequirementsAdvanced,
    deletePersonRequirementEnrollment,
    deleteEnrollmentState,
    setDeleteEnrollmentState
  };
};

export default usePersonRequirements;